// Artists.jsx
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { getArtists, getTracks } from '../api';
import usePlayerStore from '../store/playerStore';
import NavControls from '../components/NavControls';

export default function Artists() {
  const [search, setSearch] = useState('');
  const [isShuffling, setIsShuffling] = useState(false);
  const { playQueue, toggleShuffle, shuffle } = usePlayerStore();

  const { data, isLoading } = useQuery(['artists', search], () =>
    getArtists({ search }).then(r => r.data)
  );
  const artists = data?.results || [];

  const handleShuffleAll = async () => {
    setIsShuffling(true);
    try {
      const params = search
        ? { artist__name__icontains: search, page_size: 500 }
        : { page_size: 500 };
      const res = await getTracks(params);
      const tracks = res.data.results || [];
      if (!tracks.length) return;
      const shuffled = [...tracks].sort(() => Math.random() - 0.5);
      if (!shuffle) toggleShuffle();
      playQueue(shuffled, 0);
    } finally {
      setIsShuffling(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <h1>Artists</h1>
          <NavControls />
        </div>
      </div>
      <div className="search-bar" style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <input className="search-input" placeholder="Search artists…" value={search} onChange={e => setSearch(e.target.value)} />
        <button
          className="btn btn-secondary"
          onClick={handleShuffleAll}
          disabled={isShuffling}
        >
          {isShuffling ? 'Loading…' : '🔀 Shuffle All'}
        </button>
      </div>
      {isLoading ? <p style={{ color: 'var(--text-muted)' }}>Loading…</p> : (
        <div className="cards-grid">
          {artists.map(a => (
            <div key={a.id} className="card">
              <div className="card-art">🎤</div>
              <div className="card-info">
                <div className="card-title">{a.name}</div>
                <div className="card-sub">{a.track_count} tracks</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
